import './DevicesManaged.scss';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DarkButton } from '../dark-button/DarkButton';
import { ProgressBarIcon } from '../progress-bar-icon/ProgressBarIcon';
type Props = {
    color: string;
    title: string;
    linkUrl: string;
    devicesData: any;
};

export const DevicesManaged: React.FC<Props> = (props: Props) => {
    const navigate = useNavigate();

    function changeRoute() {
        if (!props.linkUrl) return;
        navigate(props.linkUrl);
    }


    const getCounts = (key: string) => {
        const item = props?.devicesData?.data?.find((entry: any) => entry.key === key)
        return item ? item?.count : 0
    }
    const sum = props.devicesData?.data.reduce((sum: any, item: any) => sum + item.count, 0)

    console.log("SUM: ", sum)

    return (
        <div className="card-widget lg:col-5 w-full ">
            <div className="card-devices-managed rounded-2xl shadow-md p-7" >
            <div className="font-medium heading-cards text-xl mb-[21px]">Managed Devices</div>
                <div className=" devices-bars d-flex gap-2" style={{ maxHeight: '320px', overflowY: 'scroll' }}>
                    <div className=' d-flex gap-3 flex-col px-2 w-1/2'>
                        <ProgressBarIcon icon="/icons/Smartphone.svg" maxvalue={100} label={'Smartphone'} count={getCounts("SMARTPHONE")}  value={Number((getCounts("SMARTPHONE")/sum * 100).toFixed(0))}/>
                        <ProgressBarIcon icon="/icons/Laptop.svg" maxvalue={100} label={'Laptop Computer'} count={getCounts("LAPTOP")}  value={Number((getCounts("LAPTOP")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/DesktopComputer.svg" maxvalue={100} label={'Desktop Computer'} count={getCounts("DESKTOP")} value={Number((getCounts("DESKTOP")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/GamesConsole.svg" maxvalue={100} label={'Games Console'} count={getCounts("GAMES_CONSOLE")}  value={Number((getCounts("GAMES_CONSOLE")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/Wearable.svg" maxvalue={100} label={'Wearable'} count={getCounts("WEARABLE")} value={Number((getCounts("WEARABLE")/sum * 100).toFixed(0))}/>
                        <ProgressBarIcon  icon="/icons/Tablet.svg"  maxvalue={100} label={'Tablet'} count={getCounts("TABLET")}   value={Number((getCounts("TABLET")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/Printer.svg"  maxvalue={100} label={'Printer'} count={getCounts("PRINTER")}   value={Number((getCounts("PRINTER")/sum * 100).toFixed(0))} />

                    </div>
                    <div className="device-line mr-4 ml-4"></div>
                    <div className=' d-flex gap-3 flex-col px-2 w-1/2'>
                        <ProgressBarIcon icon="/icons/SmartHomeDevices.svg" maxvalue={100} label={'Smart Devices'} count={getCounts("SMART_HOME_DEVICE")}  value={Number((getCounts("SMART_HOME_DEVICE")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/SmartTV.svg" maxvalue={100} label={'Smart TV'} count={getCounts("SMART_TV")}  value={Number((getCounts("SMART_TV")/sum * 100).toFixed(0))}/>
                        <ProgressBarIcon icon="/icons/SmartSpeaker.svg" maxvalue={100} label={'Smart Speaker'} count={getCounts("SMART_SPEAKER")}  value={Number((getCounts("SMART_SPEAKER")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/OtherDevices.svg"  maxvalue={100} label={'Other Devices'} count={getCounts("OTHER_CONNECTED_DEVICE")}   value={Number((getCounts("OTHER_CONNECTED_DEVICE")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/HomeSecurity.svg"  maxvalue={100} label={'Home Security Devices'} count={getCounts("HOME_SECURITY_DEVICE")}   value={Number((getCounts("HOME_SECURITY_DEVICE")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/WiFiExtenders.svg"  maxvalue={100} label={'Wifi Extender'} count={getCounts("WIFI_EXTENDER")}   value={Number((getCounts("WIFI_EXTENDER")/sum * 100).toFixed(0))} />
                        <ProgressBarIcon icon="/icons/WarningTriangle.svg" maxvalue={100} label={'Unknown'} count={getCounts("UNKNOWN")} value={Number((getCounts("UNKNOWN")/sum * 100).toFixed(0))} />

                    </div>
                </div>
                {/* <div className="devices-bars d-flex gap-2">
  <div className="col-12 d-flex gap-3 flex-col px-2">
    {props.devicesData?.map((deviceData:any, index:any) => (
      <ProgressBarIcon
        key={index}
        icon={`/icons/${deviceData[0]}.svg`}
        maxvalue={100}
        label={deviceData[0]}
        count={deviceData[1]}
        value={Number((deviceData[1] / sum * 100).toFixed(0))}
      />
    ))}
  </div>
</div> */}

            </div>
        </div>
    );
};
